// eslint-disable-next-line
import {
  getUsersCustomer,
  deleteUser,
  getAllUsers,
  getRoleActionsByRole
} from '@/api/index';
import { Mixin } from 'mc-js-lib';

export default {
  namespaced: true,
  state() {
    return ({
      users: [],
      userSelected: {},
      loadingUsers: false,
      roleActions: {}
    });
  },
  getters: {
    can: (state) => (actionKey) => {
      // We use optional chaining (?.) and !! to force a boolean true/false
      return !!state.roleActions.permissions?.[actionKey];
    },
  },
  mutations: {
    setUsers(state, usersList) {
      state.users = usersList;
      setTimeout(() => { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setUserSelected(state, user) {
      if (user) {
        state.userSelected = user;
      }
    },
    setLoading(state, status) {
      state.loadingUsers = status;
    },
    setRoleActions(state, roleActions) {
      state.roleActions = roleActions; // Commit the fetched role actions to the state
    },
  },
  actions: {
    async apiGetAllUsers({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getAllUsers(1, 10).then((res) => {
        if (res.users) {
          commit('setUsers', res.users.filter((user) => !user.deleted));
          if (state.users.length) {
            commit('setUserSelected', state.users[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiDeleteUser({
      commit,
      state,
    }) {
      await deleteUser(state.userSelected.user_id).then((res) => {
        commit('setUsers', state.users.filter((usr) => usr.user_id !== res.user_id));
        commit('setUserSelected', state.users[0]);
      });
    },

    async apiGetRoleActionsByRole({ commit }, roleId) {
      // Avoid setting global loading if you don't want to block the whole UI
      // commit('setLoading', true);
      try {
        // Expected response: { permissions: { "Detectors_addDetector": true, ... }, ... }
        const response = await getRoleActionsByRole(roleId);
        commit('setRoleActions', response);
      } catch (error) {
        console.error('Error fetching role actions by role:', error);
      } finally {
        // commit('setLoading', false);
      }
    },

  },
};
